import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { ShipListComponent } from './ship-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [ShipListComponent],
  declarations: [ShipListComponent],
})
export class ShipListModule { }
